import api from "./api";

export const cuttingService = {
  getAllCuttings: (page = 1, limit = 10) => api.get(`/cutting?page=${page}&limit=${limit}`),
  getCuttingById: (id) => api.get(`/cutting/${id}`),
  createCutting: (data) => api.post("/cutting", data),
  updateCutting: (id, data) => api.put(`/cutting/${id}`, data),
  deleteCutting: (id) => api.delete(`/cutting/${id}`),
};

